var _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetenidoZonaNoSegura(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 29,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "seg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 341.3335,
    cx: 341.3335,
    cy: 341.3335,
    className: "fill",
    fill: "none",
    shape: "circle"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7,0,0,0.7,102.39935932159426,102.400354385376)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 141.174-141.174v-199.652L0-482h-199.651l-141.175 141.174v199.652L-199.651 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(355.825 497)",
    fill: "none",
    stroke: "#656565",
    strokeWidth: 30,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-11.093 8.239-25.667 19-43 12.531C-52.911 8.833-58.363.125-58.53-7.718c-.13-6.1 2.524-13.714 9.055-17.96 8.131-5.284 14.174-4.294 28.321-9.61C-7.062-40.583-2.848-50.653-4.461-59.964c-1.858-10.723-12.905-20.183-27.611-20.183-13.759 0-25.307 6.025-32.297 13.738",
    style: {
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(128.369 288.818)",
    fill: "none",
    stroke: "#656565",
    strokeWidth: 30,
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h51.182",
    style: {
      strokeWidth: 30,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(165.33 302.34)",
    fill: "none",
    stroke: "#656565",
    strokeWidth: 30,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-89.719",
    style: {
      strokeWidth: 30,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(190.817 299.38)",
    fill: "none",
    stroke: "#656565",
    strokeWidth: 30,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-92.679",
    style: {
      strokeWidth: 30,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(393.23 302.34)",
    fill: "none",
    stroke: "#656565",
    strokeWidth: 30,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-14.444-12.222-26.154-26.666-26.154-7.164 0-25.626-.115-25.626-.115S-52.408-7.281-52.408 0c0 5.98-.064 26.154-.064 26.154h25.806C-12.222 26.154 0 14.444 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(445.702 276.185)",
    fill: "none",
    stroke: "#656565",
    strokeWidth: 30,
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-25.592-20.747-46.339-46.339-46.339-25.593 0-46.34 20.747-46.34 46.339s20.747 46.339 46.34 46.339C-20.747 46.339 0 25.592 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(344.887 256)",
    fill: "none",
    stroke: "#656565",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetenidoZonaNoSegura);
export default __webpack_public_path__ + "static/media/DetenidoZonaNoSegura.885bf254.svg";
export { ForwardRef as ReactComponent };